import { get } from 'lodash';

import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { hideConfirmModal, showConfirmModal } from 'redux-store/reducers/modal-reducer';
import { closeNotification } from 'redux-store/reducers/common-reducer';

import { ROOT_PATH, post } from 'utils/api';
import { t } from 'utils/language';

import type AdminCollabarySupportType from './AdminCollabarySupport.type';

function showMessage(message) {
  return (dispatch) => dispatch(showConfirmModal({
    message,
    confirmButtonLabel: t('action_button_ok'),
    onConfirm: () => dispatch(hideConfirmModal())
  }));
}

export function addCollabarySupportToProfile(profileId: number, profileType: AdminCollabarySupportType) {
  let url;
  if (profileType === 'influencers_agency') {
    url = `${ROOT_PATH.API}/admin/influencers-agencies/${profileId}/team`;
  } else {
    url = `${ROOT_PATH.API}/admin/${profileType}-profiles/${profileId}/team`;
  }

  return (dispatch) => {
    dispatch(showLoading(url));

    return post(url)
      .then(() => {
        dispatch(hideLoading(url));
        dispatch(showMessage(t('admin_profile_team_invite_successful')));
      })
      .catch((error) => {
        const errorCode = get(error, 'response.data.code');
        const errorMessage = errorCode === 'model.organization.duplicateMember' ?
          t('admin_profile_team_invite_warning') :
          t('unknown_error');
        dispatch(closeNotification());
        dispatch(hideLoading(url));
        dispatch(showMessage(errorMessage));
      });
  };
}
